import axios from "axios";

export const API_URL = "https://autolog.nacionaltransportes.com";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
